import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      textAlign="center"
    >
      <Typography variant="h2" color="primary" gutterBottom sx={{color:"custom.primaryBlue"}}>
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={3}>
        Sorry, the page you are looking for does not exist or has been moved.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        sx={{
          bgcolor: "custom.primaryGreen",
          color: "white",
          '&:hover': {
            bgcolor: 'custom.primaryBlue',
            color: 'white',
          },
        }}
      >
        Go to Home
      </Button>
    </Box>
  );
}
